import React from 'react';

import { Select } from '@aline/common';
import {
  gridFilterModelSelector,
  GridPanelWrapper,
  useGridApiContext,
  useGridRootProps,
  useGridSelector,
} from '@mui/x-data-grid-premium';

import { ReportFiltersPanelCore } from './report-filters-panel-core';

export interface ReportFiltersPanelProps {
  disableAddFilterButton?: boolean;
  filterableColumns?: 'all' | 'visible';
}

export const ReportFiltersPanel = React.memo(function ReportFiltersPanel({
  disableAddFilterButton = false,
  filterableColumns = 'all',
}: ReportFiltersPanelProps): JSX.Element {
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const columns =
    filterableColumns === 'all'
      ? apiRef.current.getAllColumns()
      : apiRef.current.getVisibleColumns();

  return (
    <GridPanelWrapper data-cy={Select.report.filterPanel.container}>
      <ReportFiltersPanelCore
        addFilterColumns={apiRef.current.getVisibleColumns()}
        apiRef={apiRef}
        columns={columns}
        disableAddFilterButton={rootProps.disableMultipleColumnsFiltering || disableAddFilterButton}
        filterModel={filterModel}
        localeText={{
          addFilter: String(apiRef.current.getLocaleText('filterPanelAddFilter')),
          and: String(apiRef.current.getLocaleText('filterPanelOperatorAnd')),
          deleteFilter: String(apiRef.current.getLocaleText('filterPanelDeleteIconLabel')),
          getOperatorLabel: key => apiRef.current.getLocaleText(key),
          or: String(apiRef.current.getLocaleText('filterPanelOperatorOr')),
        }}
        onFilterModelChange={nextFilterModel => apiRef.current.setFilterModel(nextFilterModel)}
      />
    </GridPanelWrapper>
  );
});
